import React from "react";
import About_the_Programme from "../assets/images/About_the_Programme.webp";

const AboutComponent = () => {
  return (
    <>
      <section className="AboutProgramme paddingTopBottom" id="scrollAboutProg">
        <div className="container">
          <div className="row">
            <div className="col-md-12  m-auto">
              <div className="row">
                <div className="col-lg-7">
                  <div className="aboutProcontent">
                    <h2 className="title">About the programme</h2>
                    <div className="aboutProcontentdetail">
                      <p className="mob-mar0">
                        The ICICI Bank Probationary Officer Program  nurtures young professionals to pursue a career in banking, with a strong focus on learning, capability building and cultural grounding. The program prepares participants to join the Bank as Relationship Managers in a Sales role, guided by the Bank’s culture of ‘Seva Bhav’—serving customers with integrity, empathy and responsibility. In a Sales role, you will engage closely with customers to understand their needs, build long-term relationships and responsibly offer appropriate banking solutions, in line with the Bank’s values of truth, trust and transparency and the principle of being Fair to the Customer and Fair to the Bank. The role involves continuous customer interactions and may require travel within and around the assigned location or city.
The program includes 2 months of structured classroom training at a residential campus, the cost of which is borne by ICICI Bank. Upon successful completion of the program, you will be placed in Relationship Management (Sales) roles at various locations across the country.
{" "} <br />
                        <b>Read more about the Program below!</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 flexD">
                  <div className="AboutProgrammeImg">
                    <img
                      src={About_the_Programme}
                      alt="About ICICI Careers Probationary Officer programme"
                      width="546px"
                      height="302px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutComponent;
